import throttle from 'lodash/throttle';
import { useState, useEffect } from 'react';

const useScrollSpy = ({
  activeSectionDefault = 0,
  offsetPx = 0,
  sectionElementRefs = [],
  throttleMs = 50,
  containerElement = window,
}) => {
  const [activeSection, setActiveSection] = useState(activeSectionDefault);

  const handle = throttle(() => {
    let currentActiveSection = activeSection;
    for (let i = 0; i < sectionElementRefs.length; i++) {
      const section = sectionElementRefs[i];
      // Needs to be a valid DOM Element
      if (!section || !(section instanceof Element)) continue;
      // GetBoundingClientRect returns values relative to viewport
      if (section.getBoundingClientRect().top + offsetPx < 0) {
        currentActiveSection = i;
        continue;
      }
      // No need to continue loop, if last element has been detected
      break;
    }
    setActiveSection(currentActiveSection);
  }, throttleMs);

  useEffect(() => {
    if (containerElement) {
      containerElement.addEventListener('scroll', handle);
      return () => {
        containerElement.removeEventListener('scroll', handle);
      };
    }
  }, [containerElement, handle]);
  return activeSection;
};

export default useScrollSpy;
